import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MarkdownContent } from '../MarkdownContent.js';
import { useRemoteUICopy } from '../copy.js';
import { MessageTimestamp } from './MessageTimestamp.js';
export function UserMessageItem({ item, timestamp, messageGroup, content }) {
    return _jsx(MessageBubble, { item: item, timestamp: timestamp, messageGroup: messageGroup, content: content });
}
export function AssistantMessageItem({ item, timestamp, messageGroup, content }) {
    return _jsx(MessageBubble, { item: item, timestamp: timestamp, messageGroup: messageGroup, content: content });
}
export function MessageItem({ item }) {
    return item.type === 'user_message'
        ? _jsx(UserMessageItem, { item: item })
        : _jsx(AssistantMessageItem, { item: item });
}
function MessageBubble({ item, timestamp, messageGroup = 'single', content }) {
    const copy = useRemoteUICopy();
    const user = item.type === 'user_message';
    return _jsxs("article", { className: `agent-timeline-item agent-message agent-message-${user ? 'user' : 'assistant'} agent-message-group-${messageGroup}`, "aria-label": user ? copy.userMessage : copy.assistantMessage, "data-message-group": messageGroup, children: [_jsxs("header", { className: "agent-item-header", children: [_jsx("span", { className: "agent-item-kicker", children: user ? copy.you : copy.assistant }), _jsx(MessageTimestamp, { timestamp: timestamp })] }), content ?? _jsx(MarkdownContent, { markdown: item.text })] });
}
//# sourceMappingURL=MessageItem.js.map